import React, { useState } from 'react';
import { useAllMainSiteContent, useDeleteMainSiteContent, useToggleMainSiteContentStatus } from "../../../api/main-site-content/main-site-content.hooks";
import { ContentPageProvider } from './context/ContentPageContext';
import ContentPageList from './components/ContentPageList';
import ContentPageBuilder from './components/ContentPageBuilder';

const ContentPage = () => {
  const [showBuilder, setShowBuilder] = useState(false);
  const [editingContent, setEditingContent] = useState(null);
  
  const { content, isError, isLoading, refetch } = useAllMainSiteContent({ type: 'content-page' });
  const { deleteContent, isLoading: isDeleting } = useDeleteMainSiteContent();
  const { toggleStatus, isLoading: isToggling } = useToggleMainSiteContentStatus();

  const handleAddNew = () => {
    setEditingContent(null);
    setShowBuilder(true);
  };

  const handleEdit = (contentItem) => {
    setEditingContent(contentItem);
    setShowBuilder(true);
  };

  const handleBack = () => {
    setShowBuilder(false);
    setEditingContent(null);
  };

  if (showBuilder) {
    return (
      <ContentPageProvider>
        <ContentPageBuilder 
          editingContent={editingContent}
          onBack={handleBack}
          refetch={refetch}
        />
      </ContentPageProvider>
    );
  }

  return (
    <div className="col-12">
      {/* Content Page List */}
      <ContentPageList 
        content={content}
        isLoading={isLoading}
        isError={isError}
        onAddNew={handleAddNew}
        onEdit={handleEdit}
        deleteContent={deleteContent}
        isDeleting={isDeleting}
        toggleStatus={toggleStatus}
        isToggling={isToggling}
        refetch={refetch}
      />
    </div>
  );
};

export default ContentPage;